import React from 'react';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';
class NewsletterForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            full_name: '',
            email: '',
            loading: false,
            message_server: '',
            is_submit: false,
        }
    }
    handleChange = (e) =>{
        this.setState({
            [e.target.name] : e.target.value
        });
    }

    handleSubmit = (e) =>{
        this.setState({loading: true});
        e.preventDefault();
        API.PRODUCTS.post('subscribe-newsletter',{
            full_name: this.state.full_name,
            email: this.state.email,
        })
        .then(resp =>{
            this.setState({
                loading: false,
                is_submit: true,
                message_server: resp.data.message,

            });
        })
        .catch(err =>{
            console.log(err);
        });

    }
    render(){
        return(
            <div className="container-fluid parallaxer mt-5">
                <div className="row">
                    <section className="col-xs-12 col-md-6 d-flex align-items-center justify-content-center">
                    <h2 className="text-subs">Suscríbete a nuestro boletín informativo</h2>
                    </section>
                    <section className="col-xs-12 col-md-6 mt-3">
                        <BarLoader
                            width={100}
                            height={4}
                            color={APP_CONFIG.spinner_color}
                            loading={this.state.loading}
                        />
                        
                        {!this.state.is_submit ? 
                        <form className="" action="#" onSubmit={this.handleSubmit} method="post">
                            
                            <div className="form-group row">              
                            <div className="col-sm-12">
                                <input type="text" onChange={this.handleChange} className="form-control form-control-sm" name="full_name" placeholder="Nombres y apellidos" required />
                            </div>
                            </div>
                            <div className="form-group row">              
                            <div className="col-sm-12">
                                <div className="input-group">
                                    <input type="email" onChange={this.handleChange} className="form-control form-control-sm" name="email" placeholder="Correo electrónico" required/>
                                    <div className="input-group-append">
                                        <button type="submit" className="btn btn-danger btn-sm">Registrarme</button>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div className="form-group form-check">
                                        <input type="checkbox" className="form-check-input" id="check" required/>
                                        <label className="form-check-label label-boletin" style={{fontSize: '0.85rem'}}> Al marcar ésta casilla acepto la <a type="button" className="btn btn-primary calcular btn-terminos" data-toggle="modal" data-target="#exampleModalterminos"> Política de protección de datos personales</a> . </label>              
                                        </div>
                                        <div className="form-group form-check">
                                        <input type="checkbox" className="form-check-input" id="check" required/>
                                        <label className="form-check-label label-boletin" style={{fontSize: '0.85rem'}}>Autorizo el tratamiento de mis datos personales para recibir ofertas y comunicaciones comerciales por parte de esta empresa.</label>              
                                        </div>
                        </form>
                        :
                        <div className="alert alert-success" role="alert">
                            {this.state.message_server} <span className="fa fa-check float-right"></span>
                        </div>
                        }
                        
                    </section>
                </div>
            </div>
        )
    }
}
export default NewsletterForm;